module.exports = __webpack_public_path__ + "img/feedback5.babc5522.png";